<template>
  <v-card
      class="preview"
      :class="{ active }"
      :style="{ backgroundImage: `url(${url})` }"
      @click="$emit('select')"
  >
    <div class="header">
      <v-fade-transition>
        <span v-if="showNotification" class="notify">
          Copied!
        </span>
      </v-fade-transition>
      <div class="buttons">
        <v-icon tag="button" class="mdi mdi-link-variant button" @click.stop="copyURL" />
        <v-icon tag="button" class="mdi mdi-delete button" @click.stop="$emit('delete', id)" />
      </div>
    </div>
    <p class="name text-subtitle-1">
      {{ name }}
    </p>
  </v-card>
</template>

<script>
  import { trimStart } from 'lodash-es'
  export default {
    name: 'ImagePreview',
    props: {
      url: {
        type: String,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      id: {
        type: String,
        required: true
      },
      active: {
        type: Boolean
      }
    },
    data () {
      return {
        notifyTimeout: null,
        showNotification: false
      }
    },
    methods: {
      copyURL () {
        clearTimeout(this.notifyTimeout)
        // Will do nothing if browser has no support for clipboard API
        navigator.clipboard?.writeText(trimStart(this.url, '/'))
        .then(() => {
          this.showNotification = true
          this.notifyTimeout = setTimeout(() => {
            this.showNotification = false
            this.notifyTimeout = null
          }, 20000)
        })
      }
    }
  }
</script>

<style lang="sass" scoped>
  @use "~/assets/sass/core/mixins.sass"
  @use "~/assets/sass/core/variables.sass" as vars
  // TODO: fix color variables
  $size-button: 24px
  $gap-button: 4px
  $count-buttons: 2
  $width-buttons: ($size-button + $gap-button * 2) * $count-buttons

  .preview
    background: center center
    background-size: cover
    padding-bottom: 100%

  .header
    border-radius: 4px 4px 0 0 !important
    box-sizing: content-box
    height: $size-button
    padding: $gap-button
    left: 0
    position: absolute
    right: 0
    top: 0
    transition-property: background-color

  .buttons
    position: absolute
    right: $gap-button
    top: $gap-button / 2

  .button
    @include mixins.square($size-button)
    font-size: $size-button
    line-height: $size-button
    padding: 0 $gap-button

  .name
    bottom: 0
    left: 0
    line-height: 2
    margin: 0
    position: absolute
    right: 0
    text-align: center
    transition-property: background-color, color

  .header,
  .name
    background-color: rgba(vars.$color-black, .35)

  .header,
  .name,
  .button,
  .notify
    transition: .4s ease-out

  .button,
  .notify,
  .name
    color: vars.$color-white

  .button,
  .notify
    transition-property: color

  .active
    .header,
    .name
      background-color: vars.$color-primary

    .button,
    .name
      color: vars.$color-black
</style>
